module.exports = "<div  class=\"pane\" [ngStyle]=\"{'width.%':with}\">\n    <ng-content></ng-content>\n</div>"